import React from 'react';

interface IAlignmentIconProps {
  style?: any;
  fill?: string;
}

export const AlignmentIcon:React.FC<IAlignmentIconProps> = (props: IAlignmentIconProps) => {
  return (
    <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M22.7006 0.652344H1.24641C0.556906 0.652344 0 1.20925 0 1.89875C0 2.58826 0.556906 3.14516 1.24641 3.14516H22.7536C23.4431 3.14516 24 2.58826 24 1.89875C24 1.20925 23.4431 0.652344 22.7006 0.652344Z" fill={props.fill ? props.fill : "#CCCCCC"}/>
      <path d="M18.9614 9.37563C19.6509 9.37563 20.2078 8.81872 20.2078 8.12922C20.2078 7.43972 19.6509 6.88281 18.9614 6.88281H4.98567C4.29616 6.88281 3.73926 7.43972 3.73926 8.12922C3.73926 8.81872 4.29616 9.37563 4.98567 9.37563H18.9614Z" fill={props.fill ? props.fill : "#CCCCCC"}/>
      <path d="M22.7006 13.1406H1.24641C0.556906 13.1406 0 13.6975 0 14.387C0 15.0765 0.556906 15.6334 1.24641 15.6334H22.7536C23.4431 15.6334 24 15.0765 24 14.387C24 13.6975 23.4431 13.1406 22.7006 13.1406Z" fill={props.fill ? props.fill : "#CCCCCC"}/>
      <path d="M18.9614 19.375H4.98567C4.29616 19.375 3.73926 19.9319 3.73926 20.6214C3.73926 21.3109 4.29616 21.8678 4.98567 21.8678H19.0144C19.7039 21.8678 20.2608 21.3109 20.2608 20.6214C20.2608 19.9319 19.7039 19.375 18.9614 19.375Z" fill={props.fill ? props.fill : "#CCCCCC"}/>
    </svg>
  )
}